import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Text } from '../text';
import { requiredDotStyle, requiredIndicatorStyle } from './styles';
function RequiredIndicator({ indicator, isRequired, size, }) {
    function renderIndicator() {
        if (indicator === 'showOptional' && !isRequired) {
            return 'Optional';
        }
        if (indicator === 'showRequired' && isRequired) {
            return (_jsxs(_Fragment, { children: [_jsx("span", { css: requiredDotStyle({ size }) }), "Required"] }));
        }
        return null;
    }
    return (_jsx(Text, Object.assign({ "aria-hidden": true, css: requiredIndicatorStyle({ size }) }, { children: renderIndicator() })));
}
export default RequiredIndicator;
